import { Card, CardContent, Grid, Typography } from '@mui/material'

export function IssueStatsBar({ stats }) {
	const kpis = [
		{ label: 'Open', value: stats.open, color: 'error.main' },
		{ label: 'In Progress', value: stats.inProgress, color: 'warning.main' },
		{ label: 'Resolved Today', value: stats.resolvedToday, color: 'success.main' },
		{ label: 'Critical Priority', value: stats.critical, color: 'error.main' },
	]

	return (
		<Grid container spacing={3} sx={{ mb: 4 }}>
			{kpis.map((kpi) => (
				<Grid item xs={12} sm={6} md={3} key={kpi.label}>
					<Card variant="outlined">
						<CardContent sx={{ py: 2.5 }}>
							<Typography variant="h4" fontWeight="bold" color={kpi.color}>
								{kpi.value}
							</Typography>
							<Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
								{kpi.label}
							</Typography>
						</CardContent>
					</Card>
				</Grid>
			))}
		</Grid>
	)
}
